import {
  IconButton,
  StarFilledIcon,
  StarIcon,
  type IconButtonProps,
} from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import styles from "./BookmarkStarButton.module.css";

export type BookmarkStarButtonProps = Omit<
  IconButtonProps,
  "children" | "text" | "variant" | "tone" | "selected" | "className"
> & {
  // 이미 북마크에 담긴 항목이면 채운 금색 별 + aria-pressed 로 표시한다.
  added: boolean;
};

// 북마크 담기 별 버튼이다. 글리프(빈 별/채운 별)와 담긴 상태의 금색을 한 곳에서 소유한다.
// 호출부는 접근성 이름·size·disabled·onClick 만 전달한다.
export function BookmarkStarButton({ added, ...rest }: BookmarkStarButtonProps): ReactNode {
  return (
    <IconButton {...rest} variant="surface" selected={added} className={styles.star}>
      {added ? <StarFilledIcon /> : <StarIcon />}
    </IconButton>
  );
}
